module.exports = __webpack_public_path__ + "static/media/b0_p13_crystal.429f4de0.mp3";